import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline'
import { LayoutLoading } from 'components/LayoutLoading'
import { useEffect, useState } from 'react'
import { getAppraisalReports, IInspectifyReport } from 'services'
import { Modal, PlainTable } from 'stories/components'
import { toTitleCaseFromSnake } from 'utils'

export const Inspectify = ({ data, onClose }: { data: Record<string, any>; onClose: Function }) => {
  const [reports, setReports] = useState<IInspectifyReport[]>([])
  const [loading, setLoading] = useState(false)

  const { orderID } = data?.thirdPartyAPI || {}

  const getReports = async () => {
    if (!orderID) return
    setLoading(true)
    try {
      const res = await getAppraisalReports('inspectify' as any, orderID)
      setReports(res.success && Array.isArray(res.data) ? res.data : [])
    } catch {
      setReports([])
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getReports()
  }, [])

  const renderReportsTable = () => {
    if (reports.length === 0 && !loading) return <div>No reports found</div>

    const tableData = reports.map((report, index) => [
      index + 1,
      <div key={`types-${index}`}>
        {(report.inspection_types || []).map((type, i) => (
          <div key={i}>{toTitleCaseFromSnake(type || '')}</div>
        ))}
      </div>,
      <div key={`names-${index}`}>{(report.template_report_names || []).join(', ') || '-'}</div>,
      report.file_url || report.web_url || report.web_latest_url ? (
        <a
          key={`link-${index}`}
          href={report.file_url || report.web_url || report.web_latest_url}
          target="_blank"
          rel="noreferrer"
        >
          <ArrowTopRightOnSquareIcon className="w-5 h-5" />
        </a>
      ) : (
        <span key={`link-${index}`}>-</span>
      ),
    ])

    return (
      <PlainTable header={['No', 'Inspection Type', 'Templates', 'Open File']} tdClass="px-4 py-2" data={tableData} />
    )
  }

  return (
    <Modal isOpen title={`Inspectify - ${orderID || ''}`} titleOkay="" onClose={() => onClose(false)}>
      <div className="relative w-[calc(100vw-5rem)] max-w-2xl overflow-hidden text-md text-gray-600">
        <LayoutLoading show={loading} />
        <div className="py-4">{renderReportsTable()}</div>
      </div>
    </Modal>
  )
}
